import React from 'react';

const HeaderAtleteModal = ({eventDetails}) => {

  return (
      <div className="col s12">
        <div className="row valign-wrapper">
          <div className="col s2">
            <img src={eventDetails.logoEvento} alt="" className="responsive-img"/ > 
          </div>
          <div className="col s8">
              <h5 className="center-align">{eventDetails.nombreEvento}</h5>
          </div>
          <div className="col s2">
          </div>
        </div>
    </div>

  )
}

export default HeaderAtleteModal;
